import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class ThanksMailService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async postThanksMail(reservationId, formData) {
    const { data, status } = await this.httpClient.post(
      `/agent/api/reservations/${reservationId}/thanks_mails`,
      formData
    )

    return { flush: data.flush, status }
  }
}

export default ThanksMailService
